// Sudeep Gumaste - https://codepen.io/sudeepgumaste/pen/abdrorB

import './Loader.scss';

const Loader = ({ msg }) => (
  <div className="loader">
    <h2>{msg}</h2>
    <div className="loader-container">
      <span className="circle" />
      <span className="circle" />
      <span className="circle" />
      <span className="circle" />
    </div>
  </div>
);

export default Loader;
